export default "__VITE_ASSET__$D_rOjWf__"